import { useFilterParam } from './hooks/useFilterParam';
import { useMapParams } from './hooks/useMapParams';
import { useJobIdParam } from './hooks/useJobIdParam';

export const URLUpdater = (): null => {
    useFilterParam();
    useMapParams();
    useJobIdParam();

    return null;
};
